import {
  useGetMeQuery,
  useUpdateCreatorMutation,
} from "@/redux/feature/user/userApi";
import { useAppSelector } from "@/redux/hooks/hooks";
import React, { useState } from "react";
import toast from "react-hot-toast";

const ToggleButton = () => {
  const { user } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email);
  const userData = data?.data;

  const [isActive, setIsActive] = useState(userData?.active);
  const [updateCreator] = useUpdateCreatorMutation();

  const toggleActiveStatus = async () => {
    const payload = {
      id: userData?.user_id,
      body: { active: !isActive },
    };

    try {
      await updateCreator(payload);
      setIsActive(!isActive);
      toast.success("Your active status changed");
    } catch (error) {
      console.error("Error updating creator:", error);
    }
  };

  return (
    <div>
      <div className="mb-6 inline-flex flex-col" id={"projects-active-status"}>
        <label className="font-medium mb-3 text-sm tracking-[-1.5%] leading-5">
          Active for Projects
        </label>
        <div className="flex items-center bg-[#EEEEEE] rounded-full">
          <button
            className={`text-xs px-8 py-1.5 rounded-full transition-colors duration-300 ${
              isActive
                ? "bg-[#2E2E2E] text-[#EEEEEE] hover:bg-gray-800"
                : "text-[#2E2E2E] hover:bg-gray-300"
            }`}
            onClick={toggleActiveStatus}
          >
            Yes
          </button>
          <button
            className={`text-xs px-8 py-1.5 rounded-full transition-colors duration-300 ${
              !isActive
                ? "bg-[#2E2E2E] text-[#EEEEEE] hover:bg-gray-800"
                : "text-[#2E2E2E] hover:bg-gray-300"
            }`}
            onClick={toggleActiveStatus}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToggleButton;
